import React, { ChangeEvent } from "react";
import { Checkbox } from "@material-ui/core";

export interface IProps {
  name: string;
  description: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  children?: React.ReactNode;
}

export const CliOption = ({
  name,
  description,
  checked,
  onChange,
  disabled = false,
  children,
}: IProps) => {
  const handleCheck = (_e: ChangeEvent<HTMLInputElement>, newChecked: boolean) => {
    onChange(newChecked);
  };

  const controlId = `cli-option-label-${name}`;

  const control = (
    <Checkbox
      id={controlId}
      checked={checked}
      onChange={handleCheck}
      name={name}
      size="small"
      disabled={disabled}
    />
  );

  return (
    <div className="cw-flex cw-items-start">
      {control}
      <div className="cw-flex cw-flex-col cw-items-start cw-p-2 cw-space-y-1">
        <label htmlFor={controlId}>
          <code className="cw-font-mono cw-text-sm">{name}</code>
          <div className="cw-font-body cw-text-xs">{description}</div>
        </label>
        <div>{children}</div>
      </div>
    </div>
  );
};
